import { render, staticRenderFns } from "./UserSalesTable.vue?vue&type=template&id=4454dac2&"
import script from "./UserSalesTable.vue?vue&type=script&lang=js&"
export * from "./UserSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports